module.exports = __webpack_public_path__ + "img/avatar-car.a230afb1.png";